import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    opportunityId: String,
  }

  connect() {
    const id = this.opportunityIdValue
    if (!id) return

    const card = this.element.querySelector(`[data-opportunity-id="${id}"]`)
    if (!card) return

    card.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
    this.scheduleRemoveHighlight(card)
  }

  scheduleRemoveHighlight(card) {
    setTimeout(() => {
      card.classList.remove("ring-2", "ring-primary-500", "dark:ring-primary-400", "ring-offset-2", "dark:ring-offset-gray-900")
    }, 4000)
  }
}
